import { WithStyles, createStyles } from '@material-ui/core';
import { color } from '../../lib/Theme/Theme';
import { SIZES } from '../../lib/Constants';

export const RegistrationConfirmationStyle = createStyles({
  registrationConfirmationContainer: {
    backgroundColor: color.secondary,
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
  },
  registrationConfirmationWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: color.light,
    maxWidth: '450px',
    width: '100%',
    height: 'max-content',
    marginTop: 100,
    padding: 15,
  },
  successLogo: {
    width: '30px',
    objectFit: 'contain',
    margin: 20,
  },
  titleText: {
    fontWeight: 500,
    fontSize: '34px',
    marginBottom: 20,
    [`@media (max-width: ${SIZES.sm}px)`]: {
      fontSize: '24px',
    },
  },
  bodyText: {
    fontSize: '12px',
    textAlign: 'center',
    width: '80%',
    marginBottom: 30,
  },
  buttonContainer: {
    marginBottom: 30,
  },
  loginButton: {
    padding: '7px 28px',
    backgroundColor: color.primary,
    '&:hover': {
      backgroundColor: color.primary,
      opacity: 0.6,
    },
  },
  loginLabel: {
    color: color.light,
    fontSize: '12px',
    textTransform: 'capitalize',
  },
  sortedLogo: {
    height: '40px',
    objectFit: 'contain',
    margin: 20,
  },
});

export interface RegistrationConfirmationComponentStyle
  extends WithStyles<typeof RegistrationConfirmationStyle> {}
